// import { Dialog, Transition } from '@headlessui/react';
// import { Fragment } from 'react';
import { ReactComponent as AddCircle } from '../../Assets/Icons/addCircle.svg';
import { ReactComponent as Transfer } from '../../Assets/Icons/transfer.svg';
// import { ReactComponent as CancelIcon } from '../../Assets/Icons/cancel.svg';
import { Dialog, Transition } from '@headlessui/react';
import React, { Fragment, useState } from 'react';
import { ObjectType } from '../../Services/constant/serviceType';
// import { shortenSentence } from '../../Utils/shorttenText';
// import { ArrowRight, Plus } from 'lucide-react';

interface LiquidateInvestmentModalProps {
  isOpen: boolean;
  onClose: () => void;
  data: ObjectType | undefined;
}

// import { Dialog, Transition } from '@headlessui/react';
// import { Fragment, useState } from 'react';
import { CheckCircle, Mail } from 'lucide-react';
import { useProperty } from '../../Services/hooks/PropertyCoOwn';
import { useSelector } from 'react-redux';
import { RootState } from '../../Storeredux/reducers/rootReducer';
import { userData } from '../../Storeredux/constants/actionTypes';
import PinInput from '../Form/InputPin';

interface LiquidateInvestmentModalProps {
  isOpen: boolean;
  data: ObjectType | undefined;
  onClose: () => void;
}

type Step =
    | 'default'
    | 'transfer'
    | 'sell'
    | 'transferOtp'
    | 'sellOtp'
    | 'success';

export default function LiquidateInvestmentModal({
  data,
  isOpen,
  onClose,
}: LiquidateInvestmentModalProps) {
  const [step, setStep] = useState<Step>('default');
  console.log(data);
  const UserState = useSelector((state: RootState) => state.user as userData);
  const { user } = UserState;
  console.log(user);
  const { transferSlot, getSlotPrice, sellSlot, sellSlotOtp, priceLoading, slotPrice } = useProperty();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [otp, setOtp] = useState('');
  const [type, setType] = useState<string>('');
  const [error, setError] = useState<string | null>(null);

  console.log(isLoading);
  const [transferData, setTransferData] = useState({
    email: '',
    slot: 0,
  });
  const [sellData, setSellData] = useState<ObjectType>({
    slot: 0,
  });
  const resetAndClose = () => {
    setStep('default');
    onClose();
  };

  const handleGetSlotPrice = async (value: number) => {
    setIsLoading(true);
    setSellData({ ...sellData, slot: value });
    const payload = {
      slot: value,
      investment_id: data?.id,
    };
    const res = await getSlotPrice(payload);
    setIsLoading(false);

    if (res.success) {
      console.log('success');
      setIsLoading(false);
    } else {
      console.log('failed');

      setIsLoading(false);
    }
  };

  const handleComplete = (pin: any) => {
    console.log('PIN entered:', pin);
    setOtp(pin);
  };


  const handleTransferSlot = async () => {
    setError(null);

    setIsLoading(true);
    const payload = {
      otp: otp,
      slot: sellData.slot,
      username: transferData.email,
      investment_id: data?.id,
      user_id: user.id,
    };
    const { success, error: errors } = await transferSlot(payload);
    setIsLoading(false);

    if (success) {
      console.log('success', success);
      setStep('success');
    } else {
      setError(errors);
    }
  };

  const handleSellSlot = async () => {
    setError(null);
    setIsLoading(true);

    const payload = {
      user_id: user.id,

      otp: otp,
      slot: sellData.slot,
      investment_id: data?.id,
    };
    const { success, error: errors } = await sellSlot(payload);
    setIsLoading(false);

    if (success) {
      console.log('success', success);
      setStep('success');
    } else {
      setError(errors);
    }
  };

  const handleTransferOtp = async () => {
    setIsLoading(true);

    const payload = {
      user_id: user.id,
    };
    const res = await sellSlotOtp(payload);
    setIsLoading(false);

    if (res.success) {
      setStep(step === 'transfer' ? 'transferOtp' : 'sellOtp');
    }
  };


  const handleSubmit = async () => {
    console.log('submit', step);
    if (step === 'transferOtp') {
      handleTransferSlot();
    }

    if (step === 'sellOtp') {
      handleSellSlot();
    }
  };

  return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={resetAndClose}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-200"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-150"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black/40"/>
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-200"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-150"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel
                                className="w-full max-w-lg transform rounded-2xl bg-white p-8 text-left align-middle shadow-xl transition-all">
                                {/* Header */}
                                <Dialog.Title className="text-xl font-semibold text-gray-900">
                                    Liquidate Investment
                                </Dialog.Title>
                                <p className="text-gray-500 mt-1 mb-6">
                                    {data?.details.property_title}
                                </p>

                                {/* MAIN MENU */}
                                {step === 'default' && (
                                    <div className="space-y-3">
                                        <button
                                            onClick={() => {
                                              setStep('transfer');
                                              setType('transfer');
                                            }}
                                            className="w-full flex items-start gap-4 p-4 border rounded-xl hover:bg-gray-50 transition"
                                        >
                                            <div className="bg-emerald-50 rounded-xl p-3">
                                                <Transfer className="text-emerald-600" />
                                            </div>
                                            <div className="text-left">
                                                <p className="text-gray-900 font-medium">
                                                    Transfer Slots
                                                </p>
                                                <p className="text-gray-500 text-sm">
                                                    Transfer ownership of your slots to another user
                                                </p>
                                            </div>
                                        </button>

                                        <button
                                            onClick={() => {
                                              setStep('sell');
                                              setType('sell');
                                            }}
                                            className="w-full flex items-start gap-4 p-4 border rounded-xl hover:bg-gray-50 transition"
                                        >
                                            <div className="bg-emerald-50 rounded-xl p-3">
                                                <AddCircle className="text-emerald-600" />
                                            </div>
                                            <div className="text-left">
                                                <p className="text-gray-900 font-medium">Sell Slots</p>
                                                <p className="text-gray-500 text-sm">
                                                    Sell your slots back to the marketplace
                                                </p>
                                            </div>
                                        </button>
                                    </div>
                                )}

                                {/* TRANSFER FORM */}
                                {step === 'transfer' && (
                                    <div className="space-y-4 mt-2">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700">
                                                Number of slots
                                            </label>
                                            <input
                                                type="number"
                                                defaultValue={sellData.slot}
                                                onChange={(e) => setSellData({ ...sellData, slot: e.target.value })}
                                                className="mt-1 w-full rounded-lg border-[0.7px] py-2 px-2 border-[#D9D9D9] focus:border-emerald-500 focus:ring-emerald-500 ring-offset-0 active:ring-offset-0 focus-visible:outline-0"                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700">
                                                Recipient email or username
                                            </label>
                                            <input
                                                type="text"
                                                onChange={(e) => setTransferData({ ...transferData, email: e.target.value })}
                                                placeholder="Enter email or username"
                                                className="mt-1 w-full rounded-lg border-[0.7px] py-2 px-2 border-[#D9D9D9] focus:border-emerald-500 focus:ring-emerald-500 ring-offset-0 active:ring-offset-0 focus-visible:outline-0"
                                            />
                                        </div>

                                        <div className="flex justify-between mt-6">
                                            <button
                                                onClick={() => setStep('default')}
                                                className="px-6 py-2 rounded-lg border text-gray-800 font-medium"
                                            >
                                                Back
                                            </button>
                                            <button
                                                onClick={handleTransferOtp}
                                                className="px-6 py-2 rounded-lg bg-emerald-600 text-white font-medium hover:bg-emerald-700"
                                                disabled={isLoading}
                                            >
                                                {isLoading ? 'Sending Otp ...' : 'Transfer'}
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {/* SELL FORM */}
                                {step === 'sell' && (
                                    <div className="space-y-4 mt-2">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700">
                                                Number of slots
                                            </label>
                                            <input
                                                type="number"
                                                onChange={(e) => handleGetSlotPrice(Number(e.target.value))}
                                                defaultValue={sellData.slot}
                                                className="mt-1 w-full rounded-lg border-[0.7px] py-2 px-2 border-[#D9D9D9] focus:border-emerald-500 focus:ring-emerald-500 ring-offset-0 active:ring-offset-0 focus-visible:outline-0"
                                            />
                                        </div>

                                        <div className="bg-emerald-50 p-4 rounded-xl">
                                            <div className="flex justify-between text-sm mb-2">
                                                <span className="text-gray-700">Current Market Price</span>
                                                <span className="font-semibold text-gray-900">
                                                  {data?.price_per_slot || '₦0'}/slot
                                                </span>
                                            </div>
                                            <div
                                                className="flex justify-between text-base font-semibold border-t border-emerald-200 pt-2">
                                                <span>Total Value</span>
                                                <span className="text-emerald-700">{ priceLoading ? 'Checking' : slotPrice}</span>
                                            </div>
                                            <p className="text-sm text-gray-500 mt-1">
                                                You are selling 1 slot at the current market price
                                            </p>
                                        </div>

                                        <div className="flex justify-between mt-6">
                                            <button
                                                onClick={() => setStep('default')}
                                                className="px-6 py-2 rounded-lg border text-gray-800 font-medium"
                                            >
                                                Back
                                            </button>
                                            <button
                                                onClick={handleTransferOtp}
                                                className="px-6 py-2 rounded-lg bg-emerald-600 text-white font-medium hover:bg-emerald-700"
                                            >
                                                {isLoading ? 'Sending Otp ...' : 'Sell'}
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {/* OTP VERIFICATION (for Transfer or Sell) */}
                                {(step === 'transferOtp' || step === 'sellOtp') && (
                                    <div className="text-center mt-4 space-y-5">
                                        <div className="flex justify-center">
                                            <div className="bg-emerald-50 p-4 rounded-full">
                                                <Mail className="text-emerald-600" size={28}/>
                                            </div>
                                        </div>

                                        <div>
                                            <h3 className="text-lg font-semibold text-gray-900">
                                                Verify OTP
                                            </h3>
                                            <p className="text-gray-500 mt-1 text-sm">
                                                We’ve sent a 6-digit code to your registered email address.
                                                Please enter it below to process this transaction.
                                            </p>
                                        </div>

                                        {/* OTP Inputs (mock) */}
                                        <div className="flex flex-col justify-center gap-2">
                                            <PinInput length={6} onComplete={handleComplete}/>
                                            {
                                                error && (
                                                    <span className="text-sm text-red-500 mt-1">{error}</span>
                                                )
                                            }
                                        </div>

                                        {/* Summary box */}
                                        <div className="bg-gray-50 p-4 rounded-xl text-left text-sm">
                                            <div className="flex justify-between mb-1">
                                                <span className="text-gray-600">Action</span>
                                                <span className="font-medium">
                          {step === 'transferOtp' ? 'Transfer Slots' : 'Sell Slots'}
                        </span>
                                            </div>
                                            <div className="flex justify-between mb-1">
                                                <span className="text-gray-600">Slots</span>
                                                <span className="font-medium">{sellData.slot} slot</span>
                                            </div>
                                            {step === 'sellOtp' && (
                                                <div className="flex justify-between">
                                                    <span className="text-gray-600">Total Value</span>
                                                    <span className="font-semibold text-emerald-700">
                                                        {slotPrice || '₦0'}
                                                      </span>
                                                </div>
                                            )}
                                        </div>

                                        <div className="flex justify-between mt-4">
                                            <button
                                                onClick={() => {
                                                  setError(null);
                                                  setStep(step === 'transferOtp' ? 'transfer' : 'sell');
                                                }
                                                }
                                                className="px-6 py-2 rounded-lg border text-gray-800 font-medium"
                                            >
                                                Back
                                            </button>
                                            <button
                                                onClick={handleSubmit}
                                                className="px-6 py-2 rounded-lg bg-emerald-600 text-white font-medium hover:bg-emerald-700"
                                            >
                                                {
                                                    isLoading ? 'Verifying...' : 'Verify & Confirm'
                                                }

                                            </button>
                                        </div>
                                    </div>
                                )}

                                {/* SUCCESS STATE */}
                                {step === 'success' && (
                                    <div className="text-center space-y-6 mt-4">
                                        <div className="flex justify-center">
                                            <CheckCircle className="text-emerald-600" size={48}/>
                                        </div>
                                        <div>
                                            <h3 className="text-lg font-semibold text-gray-900">
                                                Transaction Successful!
                                            </h3>
                                            <p className="text-gray-500 mt-1 text-sm">
                                                You have successfully sold 1 slot for ₦200,000.
                                            </p>
                                        </div>

                                        <div className="bg-gray-50 p-4 rounded-xl text-left text-sm">
                                            <p className="font-semibold text-gray-700 mb-2">
                                                Transaction Summary
                                            </p>
                                            <div className="flex justify-between mb-1">
                                                <span className="text-gray-600">Property</span>
                                                <span className="font-medium">{data?.details.property_title}</span>
                                            </div>
                                            <div className="flex justify-between mb-1">
                                                <span className="text-gray-600">Action</span>
                                                <span className="font-medium">{type === 'sell' ? 'Sell' : 'Transfer'} Slots</span>
                                            </div>
                                            <div className="flex justify-between mb-1">
                                                <span className="text-gray-600">Slots Sold</span>
                                                <span className="font-medium">{sellData.slot} slot</span>
                                            </div>
                                            {
                                                type === 'sell' && (
                                                    <div className="flex justify-between border-t border-gray-200 pt-2">
                                                        <span className="font-semibold">Total Amount</span>
                                                        <span className="font-semibold text-emerald-700">
                                                          {slotPrice || '₦0'}
                                                        </span>
                                                    </div>
                                                )
                                            }

                                        </div>


                                        {
                                            type === 'sell' && (
                                                <div className="bg-emerald-50 p-3 rounded-lg text-gray-700 text-sm">
                                                    The funds will be credited to your wallet within 24–48 hours.
                                                </div>
                                            )
                                        }


                                        <button
                                            onClick={resetAndClose}
                                            className="px-6 py-2 rounded-lg bg-emerald-600 text-white font-medium hover:bg-emerald-700"
                                        >
                                            Done
                                        </button>
                                    </div>
                                )}
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
  );
}


